















import { CustomLink, Subtext } from '../../atoms'
import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'

@Component({
  components: {
    CustomLink,
    Subtext
  },
  computed: {
    ...mapGetters(APP_MODULE, [TRANSLATE])
  },
})
export default class RegisterTermsAndCondition extends Vue {}
